import React from "react";
import './Delivery.css'
import Modal from "./DeliveryModal";
import ModalDespacho from "./DeliveryDespacho";
import LinkButton from "../LinkButton";

class DeliveryLista extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fecha: new Date().toISOString().split('T')[0],
            comandas: [
                {
                    id: 1,
                    usuario: "abedlima",
                    cliente: "Abed Nego Llovera Llanos",
                    numero: "971435299",
                    direccion: "Av. Martines de Uchuracay ",
                    referencia: "Al costado de pinos",
                    monto: 45.50,
                    creado: new Date(Date.now() - 30 * 60000),
                    estado: "Pendiente"
                },
                {
                    id: 2,
                    usuario: "abedlima",
                    cliente: "María García",
                    numero: "971435299",
                    direccion: "Calle Secundaria 456, Miraflores",
                    referencia: "Al costado de concesonaria Derco",
                    monto: 78.20,
                    creado: new Date(Date.now() - 15 * 60000),
                    estado: "Despachado"
                },
                {
                    id: 3,
                    usuario: "abedlima",
                    cliente: "Carlos López",
                    numero: "971435299",
                    direccion: "Jr. Los Olivos 789, Surco",
                    referencia: "A dos cuadras del colegio San Ramon",
                    monto: 32.00,
                    creado: new Date(Date.now() - 5 * 60000),
                    estado: "Completado"
                },
                {
                    id: 4,
                    usuario: "abedlima",
                    cliente: "Ana Mendoza",
                    numero: "971435299",
                    direccion: "Av. Libertad 321, San Isidro",
                    referencia: "A dos tres cuadras de Institucion Capagñan",
                    monto: 65.80,
                    creado: new Date(Date.now() - 45 * 60000),
                    estado: "Pendiente"
                },
            ],
            modalAbierto: false,
            comandaSeleccionada: null
        };
    }

    formatearTiempoTranscurrido(fechaCreacion) {
        const ahora = new Date();
        const diferencia = ahora - fechaCreacion;
        const minutos = Math.floor(diferencia / 60000);
        const horas = Math.floor(minutos / 60);
        
        if (horas > 0) {
            return `Hace ${horas} hora${horas > 1 ? 's' : ''}`;
        } else if (minutos > 0) {
            return `Hace ${minutos} minuto${minutos > 1 ? 's' : ''}`;
        } else {
            return "Recién creada";
        }
    }
    manejarClickEstado = (comanda) => {
        if(comanda.estado ==="Pendiente"){
            this.setState({
                modalAbierto: true,
                comandaSeleccionada: comanda
            });
        } else if (comanda.estado === "Despachado"){
            this.cambiarEstadoComanda(comanda, "Completado")
        }
    }

    cambiarEstadoComanda = (comanda, nuevoEstado) => {
        this.setState(prevState => ({
            comandas: prevState.comandas.map(c => 
                c.id === comanda.id ? {...c, estado: nuevoEstado} : c
            )
        }));
    }
    handleAsignarMotorizado = (motorizado) => {
        if (this.state.comandaSeleccionada) {
            this.cambiarEstadoComanda(this.state.comandaSeleccionada, "Despachado");
            this.cerrarModal();
            
        }
    }

    cerrarModal = () => {
        this.setState({
            modalAbierto: false,
            comandaSeleccionada: null
        });
    }

    handleFechaChange = (e) => {
        this.setState({ fecha: e.target.value });
    }



    render() {
        const { fecha, comandas, modalAbierto, comandaSeleccionada } = this.state;

        return (
            <section className="ventas-fpay-section-vh pt-4">
                <div className="container">
                    <div className="d-flex justify-content-between mb-4">
                        <p className="text-muted">Total: {comandas.length} comandas</p>
                        <LinkButton 
                            className="btn-verde-mfp mb-3 mr-2"
                            to="/add-comanda"
                        >
                            Nueva Comanda 
                        </LinkButton>
                    </div>

                    <div className="abed__comandas-horizontal-container">
                        <div className="abed__comandas-horizontal-scroll">
                            {comandas.length > 0 ? (
                                comandas.map(comanda => (
                                    <div key={comanda.id} className="abed__comanda-card">
                                        <div className="abed__comanda-header">
                                            <div className="dropdown drop-resp">
                                                <button className="btn options-ventas" type="button" data-toggle="dropdown" aria-expanded="false">
                                                </button>
                                                <div className="dropdown-menu py-1">
                                                    <div className="dropdown-item px-2">
                                                        <button className="btn btn-info btn-sm btn-block font-weight-bold" title="Enviar a Operador">
                                                            <i className="fas fa-edit"></i>
                                                            Editar
                                                        </button>
                                                    </div>
                                                    <div className="dropdown-item px-2">
                                                        <button className="btn btn-dark btn-sm btn-block font-weight-bold" title="Enviar a Operador">
                                                            <i className="fas fa-share-square"></i>
                                                            Emitir
                                                        </button>
                                                    </div>
                                                    <div className="dropdown-item px-2">
                                                        <button className="btn btn-danger btn-sm btn-block font-weight-bold" title="Enviar a Operador">
                                                            <i className="fas fa-trash"></i>
                                                            Eliminar
                                                        </button>
                                                    </div>
                                                    {/* <div className="dropdown-item px-2">
                                                        <button className="btn btn-primary btn-sm btn-block font-weight-bold" title="Enviar a Operador">
                                                            Enviar a WhatsApp
                                                        </button>
                                                    </div> */}
                                                    <div className="dropdown-item px-2">
                                                        <button className="btn btn-secondary btn-sm btn-block font-weight-bold" style={{backgroundColor:"rgb(251, 141, 0)",color:"rgb(255, 255, 255)", borderColor:"rgb(251, 141, 0)" }} title="Enviar a Operador">
                                                            <i className="far fa-file-pdf"></i>
                                                            Imprimir
                                                        </button>
                                                    </div>

                                                </div>

                                            </div>
                                            <span className="comanda-id">#{comanda.id} - {comanda.usuario}</span>
                                            <button 
                                                className={`abed__comanda-estado ${comanda.estado}`}
                                                onClick={() => this.manejarClickEstado(comanda)}
                                            >
                                                {comanda.estado}
                                            </button>
                                        </div>
                                        <div className="abed__comanda-body">
                                            <h5 className="comanda-cliente">{comanda.cliente} / {comanda.numero}</h5>
                                            <p className="comanda-direccion">
                                                <i className="fas fa-map-marker-alt"></i> 
                                                {comanda.direccion} / {comanda.referencia}
                                            </p>
                                            <div className="comanda-info">
                                                <div className="comanda-monto">
                                                    <span className="label">Monto:</span>
                                                    <span className="valor">S/ {comanda.monto.toFixed(2)}</span>
                                                </div>
                                                <div className="comanda-tiempo">
                                                    <span className="label">Creado Hace:</span>
                                                    <span className="valor">{this.formatearTiempoTranscurrido(comanda.creado)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-comandas">
                                    <i className="fas fa-clipboard-list"></i>
                                    <p>No hay comandas para esta fecha</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal 
                    isOpen={modalAbierto}
                    onClose={this.cerrarModal}
                >
                    <h6>Seleccionar motorizado: </h6>
                    <ModalDespacho 
                    onAsignarMotorizado={this.handleAsignarMotorizado}/>
                </Modal>
            </section>
        );
    }
}

export default DeliveryLista;